import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environmet';
import { DashboardStatisticsResponse, ApiResponse } from '../models/dashboard.models';

export interface DashboardParams {
  companyId?: number;
  fromDate?: string;
  toDate?: string;
  status?: string;
  paymentStatus?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/reports/dashboard`;

  getDashboardStatistics(params: DashboardParams): Observable<ApiResponse<DashboardStatisticsResponse>> {
    let httpParams = new HttpParams();
    
    if (params.companyId != null) {
      httpParams = httpParams.set('companyId', params.companyId.toString());
    }
    if (params.fromDate) {
      httpParams = httpParams.set('fromDate', params.fromDate);
    }
    if (params.toDate) {
      httpParams = httpParams.set('toDate', params.toDate);
    }
    if (params.status) {
      httpParams = httpParams.set('status', params.status);
    }
    if (params.paymentStatus) {
      httpParams = httpParams.set('paymentStatus', params.paymentStatus);
    }

    return this.http.get<ApiResponse<DashboardStatisticsResponse>>(this.baseUrl, { params: httpParams });
  }
}